import * as React from "react";
import PropTypes from "prop-types";

const CellCustomImage = (props) => {
  const marginLeft = props.marginLeft ?? props.margin ?? 0;
  const marginLeftPerc = props.marginLeftPerc ?? props.marginPerc ?? 0;
  const ml = `calc(${marginLeftPerc}% + ${marginLeft}px)`;
  const marginRight = props.marginRight ?? props.margin ?? 0;
  const marginRightPerc = props.marginRightPerc ?? props.marginPerc ?? 0;
  const mr = `calc(${marginRightPerc}% + ${marginRight}px)`;
  const width = `calc(100% - ${marginLeft + marginRight}px - ${marginLeftPerc + marginRightPerc}%)`;

  const marginTop = props.marginTop ?? props.margin ?? 0;
  const marginTopPerc = props.marginTopPerc ?? props.marginPerc ?? 0;
  const mt = `calc(${marginTopPerc}% + ${marginTop}px)`;
  const marginBottom = props.marginBottom ?? props.margin ?? 0;
  const marginBottomPerc = props.marginBottomPerc ?? props.marginPerc ?? 0;
  const mb = `calc(${marginBottomPerc}% + ${marginBottom}px)`;
  const height = `calc(100% - ${marginTop + marginBottom}px - ${marginTopPerc + marginBottomPerc}%)`;

  return (
    <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>
      <div style={{ position: "relative", width, height, left: ml, right: mr, top: mt, bottom: mb }}>
        <img
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            objectFit: "contain",
            objectPosition: "center",
          }}
          src={props.content}
          loading="lazy"
        />
      </div>
    </div>
  );
};

CellCustomImage.propTypes = {
  type: PropTypes.string.isRequired,
  content: PropTypes.string,
  margin: PropTypes.number,
  marginPerc: PropTypes.number,
  marginLeft: PropTypes.number,
  marginRight: PropTypes.number,
  marginTop: PropTypes.number,
  marginBottom: PropTypes.number,
  marginLeftPerc: PropTypes.number,
  marginRightPerc: PropTypes.number,
  marginTopPerc: PropTypes.number,
  marginBottomPerc: PropTypes.number,
};

export default CellCustomImage;
